// extracted by mini-css-extract-plugin
module.exports = {"headerRenderContainer":"SampleHeaderRenderer_headerRenderContainer_Y9BiC","alignRight":"SampleHeaderRenderer_alignRight_1Eilb","headerCell":"SampleHeaderRenderer_headerCell_2Alf4"};